var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavdiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2087 1.65219C3.38942 1.35099 3.71493 1.16669 4.06619 1.16669H12.9338C13.2851 1.16669 13.6106 1.35099 13.7913 1.65219L15.6208 4.70134C15.8463 5.07716 15.8008 5.55601 15.5085 5.88263L8.91667 13.25C8.86235 13.3055 8.79752 13.3495 8.72598 13.3796C8.65443 13.4096 8.57761 13.4251 8.5 13.4251C8.42239 13.4251 8.34557 13.4096 8.27402 13.3796C8.20247 13.3495 8.13765 13.3055 8.08333 13.25L1.49146 5.88263C1.19922 5.55601 1.15372 5.07716 1.37921 4.70134L3.2087 1.65219Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83335 7.00004L5.16669 5.16671L5.66669 4.33337",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavdiamond);
export default __webpack_public_path__ + "static/media/navdiamond.4055886a9adbf8aacdc490cc21f086bc.svg";
export { ForwardRef as ReactComponent };